export default __webpack_public_path__ + "static/media/Mark-2-Suit-02.f79a7738.jpg";